import {StyleSheet} from 'react-native';
import {scaleFonts} from '@buncha/appStyles/style/font';

export const styles = StyleSheet.create({
  parentContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    alignContent: 'center',
    flex: 1,
  },
  textStyle: {
    lineHeight: scaleFonts(30),
  },
});
